import React from "react";
import bgActive from "../../assets/bgActive.png";
import LogoPodeMorar from "../../assets/novosicones/podemorarBranco.svg";
import { ReactComponent as LogoDirecionalBranco } from "../../assets/novosicones/Direcionalwhite.svg";
import { ReactComponent as LogoRivaBranco } from "../../assets/novosicones/Rivawhite.svg";
import { ReactSVG } from "react-svg";

import { Link } from "react-router-dom";
import Fade from "@material-ui/core/Fade";

import "./styles.scss";

const AtualizarPerfil = () => {
  return (
    <Fade in>
      <div>
        <div
          className="centralized-column atualizarPerfilScreen"
          style={{ backgroundImage: `url(${bgActive})` }}
        >
          <div style={{ marginBottom: "25px" }} className="centralized-column">
            <p
              style={{
                color: "#ffffff",
                margin: "5px",
                fonSize: "18px",
                letterSpacing: "1px",
              }}
            >
              Bem vindo ao
            </p>
            <ReactSVG src={LogoPodeMorar} />
          </div>
          <div className="atualizarPerfilScreen__informations centralized-column">
            <h1>Importante</h1>
            <p>
              Mantenha seus dados cadastrais atualizados, principalmente
              telefone e email.
            </p>
            <p>
              Os dados disponibilizados nos ajudam a conhecer melhor o perfil de
              cada cliente e nos permite manter um relacionamento cada vez mais
              personalizado. Isso acontece à mesma medida em que oferecemos o
              que ele realmente necessita em termos de qualidade e agilidade nos
              serviços prestados.
            </p>

            <Link
              className="atualizarPerfilScreen__informations__toHome"
              to="/interna"
            >
              Acessar o portal do cliente
            </Link>

            <div className="atualizarPerfilScreen__informations__cta centralized-column">
              <Link to="/meu-perfil" className="btnToMeuPerfil">
                <button className="atualizarPerfilScreen__informations__cta__toAtualizarPerfil">
                  ATUALIZAR MEUS DADOS
                </button>
              </Link>
            </div>
          </div>
          <div className="centralized-space-evenly atualizarPerfilScreen__logos">
            <LogoDirecionalBranco />
            <LogoRivaBranco />
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default AtualizarPerfil;
